module.exports = __webpack_public_path__ + "uarm-fonts/glyphicons-halflings-regular.woff";